module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_kobe-6c257205e5d89a368f5bc0dcf3b85538.jpg";